import { http as atsHttp } from '@/lib/ats-https';

const getPlaceholderPreview = async (payload) => {
  const response = await atsHttp.post(`/ats_comm_templates/preview`, payload);
  return response.data;
};

export { getPlaceholderPreview };
